export default __webpack_public_path__ + "media/flags/br-dd2df2ee.svg";